import './Logo.scss';

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import routerLinks from '../../components/app/routerLinks';
import { useTranslation } from 'react-i18next';

const Logo = ({ className }) => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  let imgSrcLightAr;
  let imgSrcDarkAr;

  let imgSrcLightEn;
  let imgSrcDarkEn;

  if (pathname !== routerLinks.homePage) {
    imgSrcLightAr = '/assets/imgs/logo/Fatoorah2.png';
    imgSrcDarkAr = '/assets/imgs/logo/Fatoorah2.png';

    imgSrcLightEn = '/assets/imgs/logo/Fatoorah2.png';
    imgSrcDarkEn = '/assets/imgs/logo/Fatoorah2.png';
  } else {
    imgSrcDarkAr = '/assets/imgs/logo/Fatoorah2.png';

    imgSrcLightAr = '/assets/imgs/logo/Fatoorah2.png';

    imgSrcLightEn = '/assets/imgs/logo/Fatoorah1.png';
    imgSrcDarkEn = '/assets/imgs/logo/Fatoorah2.png';
  }
  const hanldeClick = (section) => () => {
    window.location.replace("https://fatoorah.sa/");
    //
    if (pathname !== routerLinks.homePage) {
    } else {
      document.querySelector(`.${section}`).scrollIntoView();
    }
  };
  return (
    <span
      className={`${className} ${i18n.dir()}`}
    >
      <a 
        target="_blank"
        rel='noreferrer'
        href={'https://fatoorah.sa/'}
      >
        <div className="ar">
          <img src={imgSrcLightAr} alt="app logo" className={`dark `} />
          <img src={imgSrcDarkAr} alt="app logo" className={`light`} />
        </div>
        <div className="ar-scroll">
          <img src="/assets/imgs/logo/logo.png" alt="app logo" className={`dark `} />
          <img src="/assets/imgs/logo/logo.png" alt="app logo" className={`light`} />
        </div>
        <div className="en">
          <img src={imgSrcDarkEn} alt="app logo" className={`dark`} />
          <img src={imgSrcLightEn} alt="app logo" className={`light`} />
        </div>
        <div className="en-scroll">
          <img src="/assets/imgs/logo/Fatoorah2.png" alt="app logo" className={`dark`} />
          <img src="/assets/imgs/logo/Fatoorah2.png" alt="app logo" className={`light`} />
        </div>
      </a>
    </span>
  );
};

export default Logo;
